var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerifiedAuthentihash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--sscs-interactive)",
  d: "m12 2.5 7.5 2.7v5.4c0 4.7-3.1 8.7-7.5 10.9-4.4-2.2-7.5-6.2-7.5-10.9V5.2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--sscs-text-inverse)",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M12 10.4v3m-2.1.3a3 3 0 1 1 4.2 0M8.2 15a5 5 0 1 1 7.6 0"
})));
export default SvgVerifiedAuthentihash;